import React from 'react';
import PageHeader from '../Header/PageHeader';
import Settings from './Settings';

const SettingsPage = () => {
    return (
        <div>
            <PageHeader title="تنظیمات" />
            <Settings />
        </div>
    );
};

export default SettingsPage;
